import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeaderSolutions from "../components/PageHeaderSolutions";

const LieDetection = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
         
        <div className='items-center text-center'>
              <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">Lie Detection</h3>
        </div>

        


      </section>
    </>
  );
};

export default LieDetection;
